export type AffiliatePageContext =
  | 'home'
  | 'day-review'
  | 'nutrition'
  | 'sleep'
  | 'workouts'
  | 'goals'
  | 'coach';

export type AffiliatePlacementSlot = 'footer' | 'inline';

export function pathnameToAffiliateContext(pathname: string): AffiliatePageContext | null {
  if (pathname === '/' || pathname === '') return 'home';
  if (pathname.startsWith('/day-review')) return 'day-review';
  if (pathname.startsWith('/nutrition')) return 'nutrition';
  if (pathname.startsWith('/sleep')) return 'sleep';
  if (pathname.startsWith('/workouts')) return 'workouts';
  if (pathname.startsWith('/progress')) return 'goals';
  if (pathname.startsWith('/coach')) return 'coach';
  return null;
}
